<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="400px"
    class="member-limit-dialog-box "
    :footer="null"
    :mask-closable="false"
    @cancel="TipDialogVisible=false"
  >
    <div
      v-if="type==='up'"
      class="dialog-tip-box webhook-dialog-tip"
    >
      <i class="icon iconfont iconicon-test68" />
      <h2>{{ $t('message["1882"]') }} </h2>
      <div class="d-tip-con">
        {{ $t('message["1883"]') }}
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          @click="upgrade"
        >
          {{ $t('message["599"]') }}
        </a-button>
        <a-button
          @click="TipDialogVisible=false"
        >
          {{ $t('message["1005"]') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false
    }
  },
  computed: {
  },
  methods: {
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    operateItem (val) {
      this.$emit('operateItem')
      // this.TipDialogVisible = false
    },
    upgrade () {
      this.$router.push({ name: 'ServiceIndex' })
    }
    // triggerTransfer () {
    //   this.$emit('delWebhook')
    // }
  }
}
</script>
<style lang="scss" scoped>
.webhook-dialog-tip {
  .d-tip-con {
    margin-bottom: 16px;
  }
}
</style>
